// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e87fbf3f","455":"22a01bd7","977":"c04276b5"}[chunkId] + ".chunk.js";
};